module.exports = __webpack_public_path__ + "static/media/wall-red.93753310.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall-red.png
// module id = 144
// module chunks = 0